import React from "react"
import styled from "styled-components"

import Button from "@irati/ui/src/Button"
import history from "@irati/utils/history"
import Flex from "@irati/ui/src/Flex"
import mainTheme from "@irati/ui/src/global/theme"
import {FormattedMessage} from "@irati/utils/lang"


export const Cta = () => {
  return (
    <Container wrap="wrap" gap={mainTheme.spacing.two} marginTop={mainTheme.spacing.four} marginBottom={mainTheme.spacing.eight}>
      <Button large primary full onClick={() => history.push("/perks/account/my-perks/new")}>
        <FormattedMessage
          id="flexiRewards.merchandise.success.cta.orderHistory" />
      </Button>
      <Button large full onClick={() => history.push("/rewards/categories")}>
        <FormattedMessage
          id="flexiRewards.merchandise.success.cta.back" />
      </Button>
    </Container>
  )
}

const Container = styled(Flex)`
  & > button {
    flex: 1 1 260px
  }
`
